var map = {
	"./bandera-estadosunidos.png": 6372,
	"./bandera-estadosunidos.png:Zone.Identifier": 4998,
	"./bandera-mexico.png": 2974,
	"./bandera-mexico.png:Zone.Identifier": 8957,
	"./bg.jpg": 5091,
	"./profilephoto.JPG": 6587,
	"./shape-bg.png": 3513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8568;